// ** React Imports
import { useState, useEffect, useRef } from "react";

// ** Third Party Components
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// ** Custom Components
import Selector from "components/layout/Selector/Selector";

// #####################################################

const StyledInput = styled.input`
	color: var(--dz-sys-text-color);
	width: 100%;
	${({ $isSelected }) =>
		$isSelected &&
		css`
			font-weight: bold;
		`}
`;

// #####################################################

const InputSelector = ({
	onAccept: onAcceptHook,
	label,
	type = "text",
	name,
	id,
	value: valueState = null,
	insideModalForMobileIos,
	additionalOnChangeAction,
	resetFilters,
	noPad,
	flex1,
	hideLabel,
	noMinWidth,
	selectorWrapperStyle,
	selectorSectionStyle,
	onFocus,
	additionalButton,
	autoComplete,
	isBan,
}) => {
	const [value, setValue] = useState(valueState || "");
	const [isSelected, setSelected] = useState(false);

	const inputRef = useRef(null);

	useEffect(() => {
		if (value?.length > 0 && !isSelected) {
			setSelected(true);
		} else if (value?.length === 0 || !value) {
			setSelected(false);
		}
	}, [value]);

	useEffect(() => {
		if (valueState !== value) {
			setValue(valueState);
		}
	}, [valueState]);

	const onChange = (e) => {
		const inputText = e.target.value;
		setValue(inputText);
		if (inputText.length > 0) {
			setSelected(true);
		} else {
			setSelected(false);
		}
		if (typeof additionalOnChangeAction === "function") {
			additionalOnChangeAction(inputText);
		}
	};

	// Bez tego po kliknięciu inputa klawiatura wypychała cały widok dropdowna mobile do góry na IOS.
	const onClick = () => {
		if (insideModalForMobileIos) {
			setTimeout(() => {
				window.scrollTo(0, 0);
				document.body.scrollTop = 0;
			}, 700);
		}
		if (typeof resetFilters === "function") {
			resetFilters();
		}
	};

	const onAccept = () => {
		if (value && value.length > 0) {
			setSelected(true);
		} else {
			setSelected(false);
		}
		onAcceptHook(value);
	};

	const onKeyDown = (e) => {
		if (e.key === "Enter") {
			onAccept();
		}
	};

	const handleFocus = () => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	};

	// #####################################################

	return (
		<Selector
			title={!hideLabel && label}
			noPad={noPad}
			flex1={flex1}
			noMinWidth={noMinWidth}
			style={{
				height: "var(--dz-sys-input-height)",
				...selectorWrapperStyle,
			}}
		>
			<Selector.Section
				label={label}
				cursorText
				withCaret={false}
				onClick={handleFocus}
				disabled={isBan}
				style={{ ...selectorSectionStyle }}
			>
				<StyledInput
					type={type}
					placeholder={label}
					value={value}
					name={name}
					id={id}
					autoComplete={autoComplete}
					onChange={onChange}
					onBlur={onAccept}
					onFocus={onFocus}
					onKeyDown={onKeyDown}
					onClick={onClick}
					$isSelected={isSelected}
					ref={inputRef}
				/>
			</Selector.Section>

			{additionalButton}
		</Selector>
	);
};

// #####################################################

export default InputSelector;

InputSelector.propTypes = {
	onAccept: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	// If True Change Cursor Over Text Field To TEXT Type
	cursorText: PropTypes.bool,
};

InputSelector.defaultProps = {
	cursorText: false,
};

// #####################################################
